export enum TelegramConnectionStatus {
  ACTIVE = 'ACTIVE',
  DELIVERY_FAILED = 'DELIVERY_FAILED',
  DISCONNECTED = 'DISCONNECTED',
}
